import React from 'react';
import { Helmet } from 'react-helmet-async';
import HeroSection from '../components/home/HeroSection';
import FeaturesSection from '../components/home/FeaturesSection';
import AboutSection from '../components/home/AboutSection';
import PricingSection from '../components/home/PricingSection';
import Levels from '../components/home/Levels';
import TestimonialsSection from '../components/home/TestimonialsSection';
import FAQSection from '../components/home/FAQSection';

function Home({ selectedCity }) {
  return (
    <div>
      <Helmet>
        <title>VitaLink | Internet Fibra Óptica Premium</title>
        <meta name="description" content="Planos VitaLink de 400 Mega a Ilimitado com fibra óptica pura, baixa latência, Wi-Fi 6 e suporte local." />
        <meta name="keywords" content="internet fibra óptica, planos de internet, 400 mega, 600 mega, 800 mega, ilimitado, VitaLink" />
        <meta name="author" content="VitaLink" />
        <link rel="canonical" href="https://vitalink.com.br/" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="VitaLink | Internet Fibra Óptica Premium" />
        <meta property="og:description" content="Fibra óptica pura com planos de alta performance, baixa latência e suporte local." />
        <meta property="og:image" content="https://vitalink.com.br/logo512.png" />
        <meta property="og:url" content="https://vitalink.com.br/" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="VitaLink | Internet Fibra Óptica Premium" />
        <meta name="twitter:description" content="Planos de 400 Mega a Ilimitado com fibra óptica pura e suporte local." />
        <meta name="twitter:image" content="https://vitalink.com.br/logo512.png" />
      </Helmet>

      <HeroSection selectedCity={selectedCity} />
      <FeaturesSection />
      <AboutSection />
      <PricingSection />
      <Levels />
      <TestimonialsSection />
      <FAQSection />
    </div>
  );
}

export default Home;
